import { observable, action, decorate } from 'mobx'

// this store used on form editor's page and nothing from here should save on server.
class onboardingStore {

  formBuilderTutorial = false
  formSettingsTutorial = false

  setTutorial = (bool) => {
    this.formBuilderTutorial = bool
  }
  setSettingsTutorial = (bool) => {
    this.formSettingsTutorial = bool
  }
}

decorate(onboardingStore, {
  formBuilderTutorial: observable,
  formSettingsTutorial: observable,
  setSettingsTutorial: action.bound,
  setTutorial: action.bound,
})

const OnboardingStore = new onboardingStore()
export default OnboardingStore

export function setFormBuilderTutorial(status) {
  OnboardingStore.setTutorial(status)
}
export function setFormSettingsTutorial(status) {
  OnboardingStore.setSettingsTutorial(status)
}
